export const getPaymentWord = (count: number): string => {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) return "платежей";
  if (n1 > 1 && n1 < 5) return "платежа";
  if (n1 === 1) return "платеж";

  return "платежей";
};

export const getHourWord = (count: number): string => {
  // в течении х часа
  const n = Math.abs(count) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) return "часов";
  if (n1 > 1 && n1 < 5) return "часов";
  if (n1 === 1) return "часа";

  return "часов";
};
